/**
 * Trainer Task Card — Phase 3.
 * Renders on top of /ai-trainer/coach when a verified trainer has responded
 * to a persistent issue with text/audio/video. Member can ack to dismiss.
 */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Award, Mic, Video, X } from "lucide-react";
import { apiClient } from "../../services/api";

export default function TrainerTaskCard() {
  const navigate = useNavigate();
  const [task, setTask] = useState(undefined);

  const load = () => apiClient.get("/ai-trainer/coach/trainer-task-latest").then((r) => setTask(r.data?.task || null)).catch(() => setTask(null));
  useEffect(() => { load(); }, []);

  if (!task) return null;

  const ack = async () => {
    await apiClient.post(`/ai-trainer/coach/trainer-task/${task.task_id}/ack`);
    setTask(null);
  };

  return (
    <div data-testid="trainer-task-card" style={{
      padding: 14, borderRadius: 16, position: "relative",
      background: "linear-gradient(135deg, #0C0C0B 0%, #1A1A18 100%)", color: "white",
    }}>
      <button onClick={ack} aria-label="Dismiss" data-testid="trainer-task-ack" style={{ position: "absolute", top: 10, right: 10, background: "rgba(255,255,255,0.10)", color: "white", border: "none", borderRadius: "50%", width: 26, height: 26, display: "grid", placeItems: "center" }}>
        <X size={12} />
      </button>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Award size={14} style={{ color: "#F5C518" }} />
        <span style={{ fontSize: 10, fontWeight: 700, color: "#F5C518", textTransform: "uppercase", letterSpacing: "0.10em" }}>From your trainer</span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 10 }}>
        {task.trainer_avatar ? <img src={task.trainer_avatar} alt="" width={36} height={36} style={{ borderRadius: "50%" }} /> : (
          <div style={{ width: 36, height: 36, borderRadius: "50%", background: "rgba(255,255,255,0.12)", display: "grid", placeItems: "center", fontWeight: 800 }}>{(task.trainer_name || "?").slice(0, 1).toUpperCase()}</div>
        )}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 13, fontWeight: 700 }}>{task.trainer_name || "Your trainer"}</div>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.55)" }}>responded to: <strong>{task.persistent_issue}</strong></div>
        </div>
      </div>
      {task.response_text && <p style={{ fontSize: 14, lineHeight: 1.5, marginTop: 12, color: "rgba(255,255,255,0.92)" }}>{task.response_text}</p>}
      {task.response_audio_url && (
        <div style={{ marginTop: 10, padding: 10, background: "rgba(255,255,255,0.06)", borderRadius: 12, display: "flex", alignItems: "center", gap: 8 }}>
          <Mic size={14} style={{ color: "#F5C518" }} />
          <audio controls src={task.response_audio_url} style={{ flex: 1 }} />
        </div>
      )}
      {task.response_video_url && (
        <div style={{ marginTop: 10, padding: 10, background: "rgba(255,255,255,0.06)", borderRadius: 12 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6, color: "#F5C518", fontSize: 11, fontWeight: 700, marginBottom: 6 }}><Video size={12} /> VIDEO RESPONSE</div>
          <video controls src={task.response_video_url} style={{ width: "100%", borderRadius: 8 }} />
        </div>
      )}
      <button onClick={() => navigate("/trainers")} data-testid="trainer-task-book-cta"
        style={{ marginTop: 14, width: "100%", padding: "10px 14px", background: "#F5C518", color: "#0C0C0B", border: "none", borderRadius: 100, fontFamily: "Barlow", fontSize: 12, fontWeight: 800 }}>
        Book a session →
      </button>
    </div>
  );
}
